import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

function FitOut() {
  return (
    <>
      <Container
        fluid
        style={{
          minHeight: "80vh",
        }}
        className="App"
      >
        <Row>
          <Col className="App-fitout-page-bg"></Col>
        </Row>
        <Row className="App-section App-bg-color-beige">
          <Col className="App-section-col">
            <h1
              className="tinos-regular"
              style={{
                paddingBottom: "20px",
              }}
            >
              fit-out
            </h1>
            <div className="quattrocento-sans-bold">
              We have undertaken Fit-Out projects throughout Ireland, the UK and
              Europe.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Our wide range of in-house trades are a fundamental part of how we
              deliver a successful project.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We have a hands-on management approach to every project we work on
              so that we can closely monitor workmanship, assess resource and
              proactively contribute to the decision-making process.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Our Fit-Out team are supported by our experienced design &
              management team.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We can bring your project to life from initial brief, via our
              Architectural and Interior Designers.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We can Design, Produce, Source, Install - all Furniture, Fixtures
              & Fittings
            </div>
            <br />
            <Button
              style={{
                marginBottom: "20px",
                fontFamily: "Quattrocento Sans, sans-serif",
                fontWeight: "700",
              }}
              href="mailto:HelloUrbanGroup@gmail.com"
              variant="light"
            >
              contact us
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default FitOut;
